import { IonItem } from '@ionic/react';
import { Select } from 'antd';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { showError } from '../../../config/utils/formDiffUtils';
import { PosSettings } from '../../../interfaces/company.interface';

interface Props {
  field: any;
  formik: any;
}

export const DocPos = ({ field, formik }: Props) => {
  const { t } = useTranslation();
  const formValue = useMemo(
    () => formik?.values?.[field.name]?.id || formik?.values?.[field.name],
    [formik?.values, field.name],
  );
  const hasError = useMemo(() => showError(formik, formik?.errors?.[field.name]), [formik?.errors]);

  const onChange = useCallback(
    (_value: string, option: any) => {
      formik.setFieldValue(field.name, option);
    },
    [field.name],
  );

  const getOptions = useCallback(() => {
    return field?.data?.map((option: PosSettings) => {
      return {
        label: option?.name,
        value: option.tid,
        object: option,
      };
    });
  }, [field?.data]);

  return (
    <div>
      <div className="padding-b-16 padding-l-12">{t(`SALE.${field.label}`)} *</div>
      <div key={field?.name} className="flex-center-start-column-nowrap positionRelative width-300px">
        <IonItem
          className={`width-300px border-radius-input g-select-border ${hasError && 'b-field-border-error'}`}
          mode="md">
          <Select
            optionFilterProp="children"
            className="my-ant-select normalText5"
            placeholder={t(`SALE.${field.placeholder}`) + '...'}
            variant="borderless"
            onChange={onChange}
            options={getOptions()}
            value={formValue}
          />
        </IonItem>
      </div>
    </div>
  );
};
